export default "__VITE_ASSET__8d252d09__"